const config = {
  apiHost: import.meta.env.VITE_APP_API_HOST,
  intercomId: import.meta.env.VITE_APP_INTERCOM_APP_ID,
  algoliaAppId: import.meta.env.VITE_APP_ALGOLIA_APP_ID,
  placesApiKey: import.meta.env.VITE_APP_PLACES_API_KEY,
  streamApiKey: import.meta.env.VITE_APP_STREAM_KEY,
  environment: import.meta.env.VITE_APP_ENV,
  posthog: {
    key: "phc_YnmF3UL5yq2sxfQNbxxSmfC2bmeZumDpofkSXEHB8bj",
    host: "https://us.i.posthog.com"
  },
  datadog: {
    applicationId: import.meta.env.VITE_APP_DD_APPLICATION_ID,
    clientToken: import.meta.env.VITE_APP_DD_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "client-portal",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100
  },
  stripePk: import.meta.env.VITE_APP_STRIPE_PK,
  axOrigin: import.meta.env.VITE_APP_AX_ORIGIN,
  buildId: import.meta.env.VITE_APP_SHA
};

export default config;
